import { render } from "./SnehaSparshamNotStartedReport.vue?vue&type=template&id=7c6e54c8&scoped=true"
import script from "./SnehaSparshamNotStartedReport.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamNotStartedReport.vue?vue&type=script&lang=js"

import "./SnehaSparshamNotStartedReport.vue?vue&type=style&index=0&id=7c6e54c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6e54c8"]])

export default __exports__